import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Moment from 'moment'
import  VueScrollTo from 'vue-scrollto'
import browserDetect from "vue-browser-detect-plugin"
import VueGtag from "vue-gtag";

/* Vue.use(VueGtag, {
  config: { 
    id: "G-DQ02WYB4V5",
    params: {
      send_page_view: true,
      appName: 'CVRM'
    }
  }
}) */

Vue.prototype.$moment = Moment

Vue.use(require('vue-pusher'), {
  api_key: 'ae458246b12fb963bcc4',
  options: {
      cluster: 'mt1',
      encrypted: true,
  }
});

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(VueScrollTo)
Vue.use(browserDetect)

Vue.config.productionTip = false

Vue.prototype.$eventHub = new Vue(); // Global event bus

store.dispatch('get_static', 'config.json')
  .then(resp => {
    store.commit('set_event_key_id', resp.data.event_key_id)
    store.commit('set_url', resp.data.url)
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }).catch(err => {
    console.log(err)
  })